import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { uuidValidate } from "uuid-validate";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import "./css/landing.css"
class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateData: "",
      formVisible: true,
      thankYouMessage: '',
      isOpen: false,
      photoIndex: 0,
      images: []
    };

    this.formRef = React.createRef();
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentDidMount() {
    const { match: { params } } = this.props;
    const projectId = params.projectId;

    trackSource();
    axios
      .get(`https://rscoreapi.azurewebsites.net/api/ProjectLandingPage/byprojectguid?guid=${projectId}`)
      .then((res) => {
        this.setState({ templateData: res.data });
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    // Attach listener when HTML template first loads
    if (this.formRef.current && this.state.templateData !== prevState.templateData) {
      const formEl = this.formRef.current.querySelector("form");
      console.log("Found form?", !!formEl);

      if (formEl) {
        formEl.addEventListener("submit", this.handleFormSubmit);
      } else {
        console.warn("⚠ No <form> found. Attaching fallback button click handler...");
        this.attachFallbackButtonClick();
      }
    }

    // Attach image click listeners
    if (
      this.state.templateData !== prevState.templateData ||
      this.state.formVisible !== prevState.formVisible
    ) {
      this.addImageClickListeners();
    }
  }

  componentWillUnmount() {
    const formEl = this.formRef.current?.querySelector("form");
    if (formEl) {
      formEl.removeEventListener("submit", this.handleFormSubmit);
    }
  }

  attachFallbackButtonClick = () => {
    const btn = this.formRef.current?.querySelector("button, input[type='submit']");
    if (btn) {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleFormSubmit(e);
      });
    } else {
      console.error("⚠ No submit button found either!");
    }
  };

  addImageClickListeners = () => {
    const images = this.formRef.current?.querySelectorAll(".galleryImg img");
    if (images && images.length > 0) {
      const imageUrls = Array.from(images).map((img) => img.src);
      this.setState({ images: imageUrls });

      images.forEach((img, index) => {
        img.style.cursor = "pointer";
        img.addEventListener("click", () => {
          this.setState({
            lightboxOpen: true,
            photoIndex: index
          });
        });
      });
    }
  };

  handleFormSubmit(event) {
    event.preventDefault();
    const formData = new FormData(event.target);

    const datt = {
      projectCampaignId: 3100,
      agentId: this.state.templateData.agentId,
      projectCampaignGuid: this.props.match.params.projectId,
      campaignProjectId: this.state.templateData.landingPageProjectId,
      campaignProjectGuid: this.props.match.params.projectId,
      leadSourceId: 3,
      firstName: formData.get("first_name"),
      lastName: formData.get("last_name"),
      email: formData.get("email"),
      mobile: formData.get("phone_number"),
      withAgent: formData.get("isrealtor") === "true" ? "true" : "false",
      leadSourceText: '',
    };

    toast.loading("Please wait...");
    axios
      .post("https://rscoreapi.azurewebsites.net/api/ProjectCampaignLead", datt)
      .then((response) => {
        toast.dismiss();

        if (response.data.success) {
          this.setState({
            formVisible: false,
            thankYouMessage: `We will contact you shortly to go over the next steps. If you have questions feel free to call.`,
          });
        } else {
          response.data.validationErrors.forEach((error) => {
            toast.error(error);
          });
        }
      })
      .catch((error) => {
        toast.dismiss();
        toast.error("Error submitting the form");
        console.error("There was an error submitting the form!", error);
      });
  }

  render() {
    const { templateData, lightboxOpen, photoIndex, images, formVisible, thankYouMessage } = this.state;
       const templateId = templateData?.landingPageTemplateId;
      const customCSSForTemplate8 = `
      #u_content_image_1 img{
      max-width: 100% !important;
      height: 80vh !important;
    }
     #u_column_1{
      flex: 0 0 54.77%;
      max-width: 54.77%;
     }
      #u_column_2{
        flex: 0 0 23.08%;
        max-width: 23.08%;
      }
     #u_column_8{
     margin-top: 20px !important;
    }
      #u_content_heading_3 h4{
        font-size: 16px !important;
        color: #fff !important;
        font-weight: bold !important;
      }
         #u_content_heading_2 h4{
        font-size: 16px !important;
        color: #fff !important;
        font-weight: bold !important;
      }
          #u_content_heading_1 h4{
        font-size: 16px !important;
        color: #fff !important;
        font-weight: bold !important;
      }
          #u_content_heading_4 h1{
        color: #fff !important;
        font-weight: bold !important;
      }
      #u_content_image_2 img{
      background-color: #fff !important;
      }
    `;
    const customCSSForTemplate11 = `
      #u_content_html_1 td{
        font-size: 16px !important;
        font-weight: bold !important;
      }
      #u_content_heading_3{
      padding:60px 10px 10px !important;
      }
      #u_content_heading_4 h2 {
        font-size: 18px !important;
      }
      #u_content_heading_6 h4 {
       font-size: 20px !important;
       font-weight:bold !important;
       padding-top:0px !important;
      }
      #u_content_text_5 h6{
        color:#fff !important;
      }
    `;

    const customCSSForTemplate7 = `
   #u_content_heading_1 h4{
      font-size: 16px !important;
      font-weight: bold !important;
      padding-top:0px !important
    }
      #u_content_heading_2 h4{
      font-size: 16px !important;
      font-weight: bold !important;
      padding-top:0px !important
    }
       #u_content_heading_3 h4{
      font-size: 16px !important;
      font-weight: bold !important;
      padding-top:0px !important
    }
    #u_content_heading_3{
    padding:11px 10px 10px !important;
    }
    #u_content_heading_4 h2 {
      font-size: 18px !important;
    }
    #u_content_heading_6 h4 {
     font-size: 20px !important;
     font-weight:bold !important;
     padding-top:0px !important;
    }
    #u_content_text_1 h6{
      color:#fff !important;
    }
    #u_content_heading_3{}
    #u_row_11{ display:none !important; }
    #u_content_heading_7 h4{
      font-size: 22px !important;
      
    }
      #u_content_heading_7 h4 span strong{
        font-weight: bold !important;
      }
    #u_content_heading_9 h4{
      font-size: 22px !important;
    }
       #u_content_heading_9 h4 span strong{
        font-weight: bold !important;
      }
       #u_content_heading_8 h4{
      font-size: 22px !important;
    }
       #u_content_heading_8 h4 span strong{
        font-weight: bold !important;
      }
  `;
  const customCSSForTemplate5 = `
  #u_content_html_4 img{
    height:175px !important;
    margin-bottom: 20px;
  }
  #u_content_heading_1 h4{
     font-size: 16px !important;
     font-weight: bold !important;
     padding-top:0px !important
   }
     #u_content_heading_2 h4{
     font-size: 16px !important;
     font-weight: bold !important;
     padding-top:0px !important
   }
      #u_content_heading_3 h4{
     font-size: 16px !important;
     font-weight: bold !important;
     padding-top:0px !important
   }
   #u_content_heading_3{
   padding:32px 10px 10px !important;
   }
   #u_content_heading_4 h2 {
     font-size: 18px !important;
   }
   #u_content_heading_6 h4 {
    font-size: 20px !important;
    font-weight:bold !important;
    padding-top:0px !important;
   }
  #u_content_text_6 ul li{
    
        display: block !important;
        width:100% !important;
        margin-bottom:15px;
    
  }
  form button{
    background-color:#000 !important;
  }
  #u_content_heading_17 h1{ padding-left:2rem !important; }
   #u_content_text_1 h6{
     color:#fff !important;
   }
  #u_content_heading_8 h4{ font-size:20px !important; font-weight:bold !important; padding-top: 0px;}
   #u_content_heading_10 h4{ font-size:20px !important; font-weight:bold !important; padding-top: 0px;}
    #u_content_heading_12 h4{ font-size:20px !important; font-weight:bold !important; padding-top: 0px;}
    #u_column_7{ 
    align-items: center;

    }
  #u_column_18{  align-items: center; }
  #u_column_21{  align-items: center; }
  #u_content_heading_13 h1{font-size: 18px !important;}
 `;
 const customCSSForTemplate3 = `
 #u_content_heading_1 h1{
  font-size: 32px !important;
  font-family: georgia !important;
  color: #000 !important;
  padding-top:43px;
 }
 #u_content_heading_2 h1{
    font-size: 32px !important;
  font-family: georgia !important;
  color: #000 !important;
  }
  #u_content_heading_3 h1{
    font-size: 32px !important;
  font-family: georgia !important;
  color: #000 !important;
  }
   #u_content_heading_4 h1{
    font-size: 32px !important;
  font-family: georgia !important;
  color: #000 !important;
  }
   
   #u_content_heading_5 h1{
    font-size: 32px !important;
    font-family: georgia !important;
    color: #000 !important;
  }
   #u_content_heading_6 h1{
    font-size: 32px !important;
    font-family: georgia !important;
    color: #000 !important;
  }
   #u_content_heading_7 h1{
    font-size: 32px !important;
    font-family: georgia !important;
    color: #000 !important;
  }
   #u_content_heading_8 h1{
    font-size: 32px !important;
    font-family: georgia !important;
    color: #000 !important;
  }
   #u_content_heading_9 h1{
    font-size: 32px !important;
    font-family: georgia !important;
    color: #000 !important;
    padding-top:200px;
  }
   #u_content_html_3 img{
    width:24.6% !important;
    height:175px !important;
    margin-bottom: 20px;
    margin-right:5px
  }
  #u_content_html_2 table td{ font-size: 20px; font-weight:bold; color:#ed1c24}
`;
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
          {templateId === 11 && (
          <style dangerouslySetInnerHTML={{ __html: customCSSForTemplate11 }} />
        )}
        {templateId === 13 && (
          <style dangerouslySetInnerHTML={{ __html: customCSSForTemplate7 }} />
        )}
         {templateId === 5 && (
          <style dangerouslySetInnerHTML={{ __html: customCSSForTemplate5 }} />
        )}
          {templateId === 3 && (
          <style dangerouslySetInnerHTML={{ __html: customCSSForTemplate3 }} />
        )}
          {templateId === 16 && (
          <style dangerouslySetInnerHTML={{ __html: customCSSForTemplate8 }} />
        )}
        {formVisible ? (
          <div
            ref={this.formRef}
            dangerouslySetInnerHTML={{
              __html: templateData.landingPageFullContent || "Loading content..."
            }}
          />
        ) : (
          <div className="text-center">
            <h4 className="text-danger">Thank you </h4>
            <h5>Thank you for submitting the form.</h5>
            <h5>{thankYouMessage}</h5>
          </div>
        )}

        {lightboxOpen && images.length > 0 && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ lightboxOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </React.Fragment>
    );
  }
}

function trackSource() {
  const sourceInfo = {
    source: detectSource(),
    timestamp: new Date().toISOString(),
    browser: navigator.userAgent,
    platform: getPlatform()
  };
  
 
}

function detectSource() {
  const referrer = document.referrer;
  if (referrer.includes("google.com")) return "google";
  if (referrer.includes("facebook.com")) return "facebook";
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("source") || "direct";
}

function getPlatform() {
  const platform = navigator.platform || "unknown";
  return platform.toLowerCase();
}
LandingPage.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  history:PropTypes.object
};
export default connect()(withTranslation()(LandingPage));

